import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useBlockWorker } from 'queries/admin/companyWorker/useBlockWorker'

type BlockWorkerContextState = {
  state: {
    mutationState: {
      isPending: boolean
      isSuccess: boolean
      isError: boolean
      errorMessage: string | undefined
      data: ReturnType<typeof useBlockWorker>['data']
    }
  }
  actions: {
    submit: ReturnType<typeof useBlockWorker>['mutate']
  }
}

const [Context, useBlockWorkerContextValue] =
  createContext<BlockWorkerContextState>({
    name: 'BlockWorkerContext',
  })

export const BlockWorkerProvider = ({ children }: PropsWithChildren) => {
  const { mutate, isPending, isSuccess, isError, data, error } =
    useBlockWorker()

  const value: BlockWorkerContextState = {
    state: {
      mutationState: {
        isPending,
        isSuccess,
        isError,
        errorMessage: parseErrorMessage(error),
        data,
      },
    },
    actions: { submit: mutate },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useBlockWorkerContextValue }
